import { PERMISOS } from "constants/permissions";
import { PRIVATE_ROUTE } from "../../../../routes/privateRoutes";
import { Permisos } from "types/Permisos";

interface BreadcrumbPathI {
  label: string;
  path?: string;
  permissions?: Permisos;
}

export const BREADCRUMB_OPTIONS: { [key: string]: BreadcrumbPathI[] } = {
  [PRIVATE_ROUTE.INICIO]: [{ label: "Inicio" }],

  [PRIVATE_ROUTE.NORMATIVAS]: [{ label: "Normativas" }],

  [PRIVATE_ROUTE.DISEÑOS_CURRICULARES]: [{ label: "Diseños curriculares" }],

  [PRIVATE_ROUTE.PLANES]: [{ label: "Planes" }],

  [PRIVATE_ROUTE.CAJAS_CURRICULARES]: [{ label: "Cajas curriculares" }],

  [PRIVATE_ROUTE.USUARIOS]: [{ label: "Gestión de usuarios" }],

  // [PRIVATE_ROUTE.NOTIFICACIONES_CREAR]: [
  //     { label: "Notificaciones", path: PRIVATE_ROUTE.NOTIFICACIONES },
  //     { label: "Nueva notificación" },
  // ],
};

const adaptPathname = (pathName: string) => {
  const splited = pathName.split("/");

  const mapped = splited.map((ctString) =>
    !ctString ? "" : ctString.includes(":") ? "n" : ctString,
  );

  const joined = mapped.join("/");
  return joined;
};

const converPathParamIntoN = (pathName: string) => {
  const adaptedPathname = pathName
    .split("/")
    .map((ctString) =>
      !ctString ? "" : isNaN(Number(ctString)) ? ctString : "n",
    )
    .join("/");
  return adaptedPathname;
};

export const getBreadcrumbOptions = (pathName: string) => {
  const convetedPath = converPathParamIntoN(pathName);
  const adaptedOptions: { [key: string]: BreadcrumbPathI[] } = {};
  Object.keys(BREADCRUMB_OPTIONS).forEach(
    (ctKey) =>
      (adaptedOptions[adaptPathname(ctKey)] = BREADCRUMB_OPTIONS[ctKey]),
  );
  return adaptedOptions[convetedPath];
};
